import { handleHideModal } from 'components/global/_helpers/global.helpers';
import SimpleModal from 'components/global/SimpleModal';
import { handleSubmitDeletePortfolio } from 'components/views/InvestorPortfolioList/_helpers/investorPortfolioList.events';
import { $form, $view } from 'signals/global.signals';

const InvestorPortfolioDeleteModal = () => (
  <SimpleModal
    show={$view.value?.activeModal === 'investor-portfolio-delete'}
    title="Delete Portfolio Entry"
    isLoading={$view.value?.isModalLoading}
    onHide={handleHideModal}
    onPrimaryClick={handleSubmitDeletePortfolio}
    primaryButtonText="Delete"
    secondaryButtonText="Cancel"
    onSecondaryClick={handleHideModal}
  >
    Are you sure you want to delete <span className="text-warning">{`${$form.value.companyName}`}</span>?
  </SimpleModal>

);

export default InvestorPortfolioDeleteModal;
